import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aditya-termsconditions',
  templateUrl: './termsconditions.component.html',
  styleUrls: ['./termsconditions.component.css']
})
export class TermsconditionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
